module.exports = __webpack_public_path__ + "static/img/13-2.34e2cf1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/13-2.jpg
// module id = HLLy
// module chunks = 0